import { render, staticRenderFns } from "./FileFormats.vue?vue&type=template&id=1637cc65"
import script from "./FileFormats.vue?vue&type=script&lang=js"
export * from "./FileFormats.vue?vue&type=script&lang=js"
import style0 from "./FileFormats.vue?vue&type=style&index=0&id=1637cc65&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports